import React, { useState } from "react";
import { IconButton, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import AddTodo from "./AddTodo";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import ArchiveIcon from "@mui/icons-material/Archive";
import AutoSearch from "components/AutoSearch/AutoSearch";

import TodoDrag from "./TodoDrag";
import ArchiveModal from "./ArchiveTodo";
import "./todo.css";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteTodo } from "api/all.api";
import { updateTodo } from "api/all.api";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // paddingTop: theme.spacing(2),
  height: "41px",
  borderRadius: "0",
  textAlign: "center",
  color: "#000",
}));

const ItemSearch = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  borderRadius: "0",
  textAlign: "center",
  color: "#000",
}));

export default function Todo({ todos, archiveTodos }) {
  const [todoInput, setTodoInput] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectTodo, setSelectTodos] = useState([]);

  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: deleteTodo,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(["todos"], (oldTodos) =>
          oldTodos?.filter((todo) => todo._id !== variables._id)
        );
        if (archiveTodos !== undefined)
          queryClient.setQueryData(["arvhivetodos"], (oldTodos) => [
            ...oldTodos,
            data.todo,
          ]);

        toast.success(data.message);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });

  const updateMutation = useMutation({
    mutationFn: updateTodo,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(["todos"], (oldTodos) =>
          oldTodos.map((item, i) =>
            item._id === variables.id
              ? { ...item, isComplete: variables.data.isComplete }
              : item
          )
        );

        toast.success(data.message);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });

  const handleTodo = () => {
    setTodoInput(true);
  };

  const handleDelete = (item) => {
    deleteMutation.mutate(item);
  };

  const handleUpdate = (id, isComplete) => {
    const data = {
      isComplete: isComplete,
    };

    updateMutation.mutate({ id, data });
  };

  const handleArchive = () => setOpen(true);

  return (
    <Box className="todo-container">
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
      >
        <Item className="d-flex justify-content-between">
          <div className="font-weight-bold">To-do</div>
          <div>
            {archiveTodos && (
              <IconButton size="small" className="pt-0" onClick={handleArchive}>
                <ArchiveIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton size="small" className="pt-0" onClick={handleTodo}>
              <AddIcon fontSize="small" />
            </IconButton>
          </div>
        </Item>
        <ItemSearch>
          <AutoSearch
            items={todos}
            setSearchItem={setSelectTodos}
            isTodo={true}
          />
        </ItemSearch>
        {todoInput && <AddTodo open={todoInput} setOpen={setTodoInput} />}
        <TodoDrag
          todos={selectTodo.length ? selectTodo : todos}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
        />
      </Stack>
      <ArchiveModal open={open} setOpen={setOpen} archiveTodos={archiveTodos} />
    </Box>
  );
}
